let pick_data3 = [
    {
        id : 88,
        imgurl : '/img/section7/section7_men1.jpg',
        brand : 'ILCORSO',
        title : '에센셜 컴포트 반팔 셔츠 오렌지',
        persent : '20%',
        price : '79,000',
        saleprice : '63,000',
    },
    {
        id : 89,
        imgurl : '/img/section7/section7_men2.jpg',
        brand : 'ILCORSO',
        title : '에센셜 컴포트 반팔 셔츠 화이트',
        persent : '15%',
        price : '79,000',
        saleprice : '67,000',
    },
    {
        id : 90,
        imgurl : '/img/section7/section7_men3.jpg',
        brand : 'DAKS MEN',
        title : '블루 버튼다운 린넨 반팔캐주얼셔츠',
        persent : '28%',
        price : '149,000',
        saleprice : '106,160',
    },
    {
        id : 91,
        imgurl : '/img/section7/section7_men4.jpg',
        brand : 'GUESS',
        title : '유니 세미오버핏 스트라이프 반팔티',
        persent : '47%',
        price : '48,000',
        saleprice : '25,200',
    },
    {
        id : 92,
        imgurl : '/img/section7/section7_men5.jpg',
        brand : 'HAZZYS MEN',
        title : '[말콤] 반팔 카라',
        persent : '34%',
        price : '139,000',
        saleprice : '91,740',
    },
    {
        id : 93,
        imgurl : '/img/section7/section7_men6.jpg',
        brand : 'HAZZYS MEN',
        title : '[보윅] 피케티',
        persent : '34%',
        price : '119,000',
        saleprice : '78,540',
    },
    {
        id : 94,
        imgurl : '/img/section7/section7_men7.jpg',
        brand : 'MAESTRO MEN',
        title : '썸머 네이비 울 팬츠',
        persent : '36%',
        price : '149,000',
        saleprice : '94,230',
    },
    {
        id : 95,
        imgurl : '/img/section7/section7_men8.jpg',
        brand : 'OUTDOOR PRODUCTS',
        title : '캠프사이트 티셔츠',
        persent : '27%',
        price : '59,900',
        saleprice : '43,130',
    }
]

export default pick_data3;